<mat-card class="landing-card">{{ 'COMMON.COMING_SOON' | translate }}</mat-card>
